// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3AH77","header":"ReportDetails_header__2PxSU","title":"ReportDetails_title__2vMqT","left":"ReportDetails_left__2ko-f"};